module.exports = __webpack_public_path__ + "static/media/holding-apple.60409df3.jpeg";